import React from 'react';

/**
 * Mira — Fashdeck's guide. Chibi fashion character: bob, clay clip, signal jacket, swatch.
 */
const MascotMark = ({ className = '', waving = true }) => (
  <svg
    viewBox="0 0 140 156"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <ellipse cx="78" cy="148" rx="26" ry="5" fill="#141413" opacity="0.16" />
    <g className="mira-bob">
      <rect x="54" y="96" width="48" height="40" rx="16" fill="#5424e4" />
      <path d="M68 96h20l-10 14z" fill="#faf9f5" />
      <path d="M66 100c4 7 16 7 20 0" fill="none" stroke="#d97757" strokeWidth="3" strokeLinecap="round" />
      <circle cx="86" cy="116" r="5" fill="#d97757" />
      <circle cx="86" cy="116" r="2" fill="#faf9f5" />
      <ellipse cx="66" cy="134" rx="7" ry="3.5" fill="#141413" />
      <ellipse cx="90" cy="134" rx="7" ry="3.5" fill="#141413" />

      <g className={waving ? 'mira-arm' : undefined}>
        <path
          d="M58 108C40 100 28 84 32 70"
          fill="none"
          stroke="#5424e4"
          strokeWidth="8"
          strokeLinecap="round"
        />
        <circle cx="30" cy="64" r="7" fill="#f3c4a6" />
      </g>

      <path
        d="M100 110c12 6 16 16 10 24"
        fill="none"
        stroke="#5424e4"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <circle cx="108" cy="134" r="6.5" fill="#f3c4a6" />
      <g transform="translate(96 112) rotate(-8)">
        <rect x="0" y="0" width="15" height="17" rx="2" fill="#fffdf8" stroke="#d97757" strokeWidth="1.3" />
        <path d="M0 6h15M0 11h15M7.5 0v17" stroke="#d97757" strokeWidth="0.8" opacity="0.8" />
      </g>

      <circle cx="46" cy="66" r="5" fill="#f3c4a6" />
      <circle cx="110" cy="66" r="5" fill="#f3c4a6" />
      <circle cx="78" cy="62" r="28" fill="#f3c4a6" />
      <path
        d="M52 66c-1-24 10-40 26-40s28 16 26 40c-6-12-14-18-26-18s-20 6-26 18z"
        fill="#141413"
      />
      <path
        d="M56 58c6-12 14-16 22-15 8-1 16 3 22 15-8-2-14 4-22 2-8 2-14-4-22-2z"
        fill="#141413"
      />
      <rect x="96" y="36" width="12" height="5" rx="2.5" fill="#d97757" transform="rotate(28 102 38)" />
      <g className="mira-eyes">
        <ellipse cx="68" cy="70" rx="3.1" ry="3.5" fill="#141413" />
        <ellipse cx="88" cy="70" rx="3.1" ry="3.5" fill="#141413" />
        <circle cx="69.1" cy="68.8" r="1" fill="#fff" />
        <circle cx="89.1" cy="68.8" r="1" fill="#fff" />
      </g>
      <path d="M70 80c3.2 3.6 9.6 3.6 12.8 0" fill="none" stroke="#141413" strokeWidth="1.7" strokeLinecap="round" />
      <ellipse cx="60" cy="78" rx="4" ry="2" fill="#d97757" opacity="0.4" />
      <ellipse cx="96" cy="78" rx="4" ry="2" fill="#d97757" opacity="0.4" />
    </g>
  </svg>
);

export default MascotMark;
